
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $bd66ebaaf526fb3e$exports = {};
Object.defineProperty($bd66ebaaf526fb3e$exports, "__esModule", {
    value: true
});
$bd66ebaaf526fb3e$exports["default"] = $bd66ebaaf526fb3e$var$isTouchDevice;
function $bd66ebaaf526fb3e$var$isTouchDevice() {
    return !!(typeof window !== "undefined" && ("ontouchstart" in window || window.DocumentTouch && typeof document !== "undefined" && document instanceof window.DocumentTouch)) || !!(typeof navigator !== "undefined" && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
}
$bd66ebaaf526fb3e$exports = $bd66ebaaf526fb3e$exports["default"];


const $a77de0ab73e8789f$var$images = document.getElementById("images__container");
const $a77de0ab73e8789f$var$mediaSection = document.getElementById("media");
const $a77de0ab73e8789f$var$video = document.getElementById("video");
const $a77de0ab73e8789f$var$isTouch = (0, (/*@__PURE__*/$parcel$interopDefault($bd66ebaaf526fb3e$exports)))();
// Variables
let $a77de0ab73e8789f$var$timeout = null;
let $a77de0ab73e8789f$var$activeIndex = 0;
// Functions
const $a77de0ab73e8789f$var$onMouseEnter = ()=>{
    if ($a77de0ab73e8789f$var$isTouch) return;
    clearTimeout($a77de0ab73e8789f$var$timeout);
    $a77de0ab73e8789f$var$timeout = null;
};
const $a77de0ab73e8789f$var$onMouseLeave = ()=>{
    if ($a77de0ab73e8789f$var$isTouch) return;
    $a77de0ab73e8789f$var$animateImages($a77de0ab73e8789f$var$activeIndex);
};
const $a77de0ab73e8789f$var$onTouchStart = (e)=>{
    e.preventDefault();
    if ($a77de0ab73e8789f$var$timeout) {
        clearTimeout($a77de0ab73e8789f$var$timeout);
        $a77de0ab73e8789f$var$timeout = null;
    }
};
const $a77de0ab73e8789f$var$onTouchEnd = (e)=>{
    if (e.touches.length === 0) $a77de0ab73e8789f$var$animateImages($a77de0ab73e8789f$var$activeIndex);
};
const $a77de0ab73e8789f$var$onMouseEnterVideo = ()=>{
    if ($a77de0ab73e8789f$var$isTouch) return;
    $a77de0ab73e8789f$var$video.pause();
};
const $a77de0ab73e8789f$var$onMouseLeaveVideo = ()=>{
    if ($a77de0ab73e8789f$var$isTouch) return;
    $a77de0ab73e8789f$var$video.play();
};
const $a77de0ab73e8789f$var$onTouchStartVideo = (e)=>{
    e.preventDefault();
    $a77de0ab73e8789f$var$video.pause();
};
const $a77de0ab73e8789f$var$onTouchEndVideo = (e)=>{
    if (e.touches.length === 0) $a77de0ab73e8789f$var$video.play();
};
const $a77de0ab73e8789f$var$animateImages = (i)=>{
    $a77de0ab73e8789f$var$activeIndex = i;
    $a77de0ab73e8789f$var$images.children[i].style.opacity = 1;
    const nextIndex = i === $a77de0ab73e8789f$var$images.children.length - 1 ? 0 : i + 1;
    $a77de0ab73e8789f$var$timeout = setTimeout(()=>{
        $a77de0ab73e8789f$var$images.children[i].style.opacity = 0;
        $a77de0ab73e8789f$var$animateImages(nextIndex);
    }, 250);
};
// Event Listeners
if ($a77de0ab73e8789f$var$images) {
    $a77de0ab73e8789f$var$images.addEventListener("mouseenter", $a77de0ab73e8789f$var$onMouseEnter);
    $a77de0ab73e8789f$var$images.addEventListener("mouseleave", $a77de0ab73e8789f$var$onMouseLeave);
    $a77de0ab73e8789f$var$images.addEventListener("touchstart", $a77de0ab73e8789f$var$onTouchStart);
    $a77de0ab73e8789f$var$images.addEventListener("touchend", $a77de0ab73e8789f$var$onTouchEnd);
    $a77de0ab73e8789f$var$animateImages(0);
}
if ($a77de0ab73e8789f$var$video) {
    $a77de0ab73e8789f$var$video.addEventListener("mouseenter", $a77de0ab73e8789f$var$onMouseEnterVideo);
    $a77de0ab73e8789f$var$video.addEventListener("mouseleave", $a77de0ab73e8789f$var$onMouseLeaveVideo);
    $a77de0ab73e8789f$var$video.addEventListener("touchstart", $a77de0ab73e8789f$var$onTouchStartVideo);
    $a77de0ab73e8789f$var$video.addEventListener("touchend", $a77de0ab73e8789f$var$onTouchEndVideo);
}
$a77de0ab73e8789f$var$mediaSection.style.opacity = 1;


//# sourceMappingURL=index.ff1e9213.js.map
